import { render, staticRenderFns } from "./PricingServicesPopups.vue?vue&type=template&id=3e477072&lang=pug"
import script from "./PricingServicesPopups.vue?vue&type=script&lang=ts"
export * from "./PricingServicesPopups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports